import { render, staticRenderFns } from "./userAllowance.vue?vue&type=template&id=1ade1fe9&scoped=true&"
import script from "./userAllowance.vue?vue&type=script&lang=js&"
export * from "./userAllowance.vue?vue&type=script&lang=js&"
import style0 from "./userAllowance.vue?vue&type=style&index=0&id=1ade1fe9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ade1fe9",
  null
  
)

export default component.exports